import Message from "@common/ict/components/message";
import { RequestBaseService } from "../request";
import { getStorage, setStorage } from "@common/utils";

const RequestService = new RequestBaseService();

RequestService.setRequestInterceptors(config => {
  return config;
});
RequestService.setResponseInterceptors(function(response) {
  // Do something with response data
  const data = response.data;
  if (data.status === 4000403) {
    //官网前台不做登录，理应无403
    Message.warning(data.data);
    // Message.closeAll();
    // setTimeout(() => {
    //   LoginService.logout();
    // }, 1000);
    return Promise.reject(data);
  }
  const isBlob = Object.prototype.toString.call(data) === "[object Blob]";
  if (data.status) {
    if (data.status != 4000200) {
      Message.error(data.message);
      return Promise.reject(data);
    }
  }

  return data;
});
export default RequestService.axios;
